// import { GET_ALL_PRODUCTS } from "./Types";
import axios from "axios";
import { useToast } from "vue-toastification";
const toast = useToast();
import { globals } from "../../main";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { param } from "jquery";
import ShortenUrl from "../../views/redirections/shortenUrl.vue";

// initial state
const state = () => getDefaultState();

const getDefaultState = () => ({
  user: {},
  userObject: {},
  updatedUser: {},
  isSilentLogin: true,
  apiCallback: true,

  //View Appointment
  getAppointmentDetails: true,
  apptDetail: {},

  // Mark as enroute and Arrived actions
  appointmentAction: true,
  saveApptointmentActionEnroute: {},
  saveApptointmentActionArrived: {},

  //Start Quote
  saveApptointmentCreatelObject: {},

  //Company Info
  setCompanyInfo: true,
  saveCompanyInfo: {},

  //Get Equipment Info
  setEquipmentInfo: true,
  saveEquipmentInfo: {},
  saveHvacEquipmentInfo: {},
  saveHvacConfig: {},

  //Store Equipment Info
  saveEquipmentInfoStore: {},
  saveHvacEquipmentInfoStore: {},
  setEquipmentInfoStore: true,

  //Notes Info
  notesData: {},

  //Part Categories
  partCategories: [],

  //Part List
  partList: [],

  // Store Quote Items
  storeQuoteItems: {},

  // Store Quote Details
  quoteDetail: {},

  cancelReasons: [],

  //CancelAppoiuntment Response
  cancelAppointment: {},

  quoteSummary: {},

  updateQuoteSummary: {},

  componentState: "ClaimDetails",

  qouteNotes: [],

  checkoutResponse: {},
  qrResponse: {},

  quoteEmailResponse: {},
  quoteImageUploaded: {},
  bookingImageUploaded: {},

  quoteImages: [],
  deleteQuoteImage: false,

  dashboardData: {},
  QRData: {},
  inProgressJobs: [],
  completedJobs: [],
  jobDetail: {},
  bookingDiagnosisItems: {},
  diagnosisSubmitResponse: {},
  diagnosisUpdateResponse: {},
  postUnitResponse: {},
  bindUnitResponse: {},
  collectDataResponse: {},
  updateCollectDataResponse: {},
  updateJobStatusResponse: {},
  resumeJobResponse: {},
  endJobResponse: {},
  resubmitQuoteResponse: {},
  bookingResponse: {},
  storeChecksResponse: {},
  bookingNotes: [],
  markAsCompleteObject: {},
  partsDetails: [],
  unitsList: [],
  initialChecksList: {},
  consumerMembers: [],
  equipmentChecksList: {},
  services: {},
  bookingServices: {},
  bookingParts: [],
  bookingDiagnosisOptions: [],
  getDiagnosisOptions: {},
  allDiagnosisOptions: {},
  markAsCompleteResponse: {},
  preChecksDetail: [],
  specialParts: [],
  summaryDetail: {},
  preChecksStore: {},
  preConfig: {},
  config: {},
  bookingConverted: {},
  bookingDocs: [],
  removeBookingDocs: {},
  deleteNoteResponse: {},
  addNoteResponse: {},
  componentList: [],
  waiveTradeCallFee: false,
  resubmitQuote: false,
  maintenanceBannerData: {},
  protectionPlans: {},
  protectionPlanDetails: {},
  protectionPlanBundleDetailsCallBack: {},
  cartCountResponse: {},
  cartDetails: [],
  cartUpdated: {},
  consumerDetails: {},
  consumerAddresses: [],
  consumerBindCartResponse: {},
  cartCheckoutResponse: {},
  protectionPlanSalesListing: [],
  billingTransactionListing: [],
  paymentCardListing: [],
  commissionsList: [],
  deleteAddressResponse: {},
  formattedAddress: {},
  consumerAddressStoreResponse: {},
  addConsumerResponse: {},
  salesPlanDetails: {},
  companyReferalCode: {},
  resendCodeResponse: {},
  updateStatusResponse: {},
  signOutResponse: null,
  notificationResponse: {},
  notificationCountResponse: null,
  searchResults: null,
  resetAuthResponse: null,
  resetResendCodeResponse: null,
  resetVerifyResponse: null,
  resetPasswordResponse: null,
  quoteItems: [],
  isSSOLogin: false,
  shareProtectionPlanData: {},
  sendProtectionPlanURLCallBack: {},
  protectionPlanBundle: {},
  protectionPlanBundleAddons: {},
  cartValidate: {},
  removeProtectionCartData: {},
  selectedProtectionPlan: '',
  bundleQuantityUpdated: false,
  shareProtectionPlans: {},
  shareProtectionPlanURL: {},
  sendProtectionPlanURLResponse: {},
  previousEvaluation: null,
  previousEvaluationResponse: null,
  createInvoiceResponse: {},
  invoiceDetail: {},
  quoteCheckoutResponse: {},
  notesDataResponse: {},
  signaturePaymentLinkResponse: {},
  paymentLinkCheckoutResponse: {},
  sideMenuData: {},
  userAccountDetails: {},
  uploadMediaResponse: {},
  internalCheckoutResponse: {},
  termsAndConditionsResponse: {},
  affiliateList: {},
  affiliateDetails: {},
  updateAffiliateResponse: {},
  passwordResetResponse: {},
  addonPlanDetails: {},
  connectivityCheckDetails: {},
  connectivityInitDetails: {},
  comissionSummary: {},
  stripDisconnect: {},
  stripLogin: {},
  stripConnect: {},
  updatePrivacyPolicyDetails: {},
  updateContractorAgreementDetails: {},
  affiliateConfig: {},
  updatePasswordResponse: {},
  contactUsResponse: {},
  requestOtpResponse: {},
  userRegisterResponse: {},
  userVerifyResponse: {},
  consumerCartUpdateResponse: {},
  cartModalState: false,
  purchaseCancelValidateResponse: {},
  cardDefaultResponse: {},
  cardDeleteResponse: {},
  purchasePlanCancelResponse: {},
  socialUserResponse: {},
  addCreditCardResponse: {},
  shortenUrlResponse: {},
  clientIdentifierResponse: {},
  checkoutTotalResponse: {},
  bindPromoCodeResponse: {},
  sidebarCollapsedState: localStorage.getItem('sidebarCollapsed'),
  claimConfig : {},
  claimAgreements : {},
  agreementAddresses: {},
  agreementDetails: {},
  claimResponse: {},
  unbindPromoCodeResponse: {},
  workOrderListing: {},
  workOrderDetailResponse: {},
  cancelClaimReasons: [],
  cancelClaimResponse: {},
  paymentRetryObject: {},
  paymentRetryResponse: {},
  ratingReviewConfigResponse: null,
  ratingReviewResponse: {},
  claimResheduleResponse: {},
  userFailedResponse: {},
  failedInvoices : {},
  paymentCollectResponse : {},
  paymentCollectFailResponse : {}
});

// getters
const getters = {
  user: (state) => state.user,
  userObject: (state) => state.userObject,
  updatedUser: (state) => state.updatedUser,
  isSilentLogin: (state) => state.isSilentLogin,
  isSSOLogin: (state) => state.isSSOLogin,
  apiCallback: (state) => state.apiCallback,

  //View Appointment
  getAppointmentDetails: (state) => state.getAppointmentDetails,
  apptDetail: (state) => state.apptDetail,

  //Mark as enroute and Arrived actions
  appointmentAction: (state) => state.appointmentAction,
  saveApptointmentActionEnroute: (state) => state.saveApptointmentActionEnroute,
  saveApptointmentActionArrived: (state) => state.saveApptointmentActionArrived,

  //Start Quote
  saveApptointmentCreatelObject: (state) => state.saveApptointmentCreatelObject,

  //Company Info
  setCompanyInfo: (state) => state.setCompanyInfo,
  saveCompanyInfo: (state) => state.saveCompanyInfo,

  //Get Equipment Info
  setEquipmentInfo: (state) => state.setEquipmentInfo,
  saveEquipmentInfo: (state) => state.saveEquipmentInfo,
  saveHvacEquipmentInfo: (state) => state.saveHvacEquipmentInfo,
  saveHvacConfig: (state) => state.saveHvacConfig,

  //Store Equipment Info
  saveEquipmentInfoStore: (state) => state.saveEquipmentInfoStore,
  saveHvacEquipmentInfoStore: (state) => state.saveHvacEquipmentInfoStore,
  setEquipmentInfoStore: (state) => state.setEquipmentInfoStore,

  //Notes Info
  notesData: (state) => state.notesData,

  //Part Categories
  partCategories: (state) => state.partCategories,

  partList: (state) => state.partList,

  storeQuoteItems: (state) => state.storeQuoteItems,

  quoteDetail: (state) => state.quoteDetail,

  cancelReasons: (state) => state.cancelReasons,

  quoteSummary: (state) => state.quoteSummary,

  updateQuoteSummary: (state) => state.updateQuoteSummary,

  componentState: (state) => state.componentState,

  qouteNotes: (state) => state.qouteNotes,

  cancelAppointment: (state) => state.cancelAppointment,

  checkoutResponse: (state) => state.checkoutResponse,
  qrResponse: (state) => state.qrResponse,
  quoteEmailResponse: (state) => state.quoteEmailResponse,
  quoteImageUploaded: (state) => state.quoteImageUploaded,
  bookingImageUploaded: (state) => state.bookingImageUploaded,
  quoteImages: (state) => state.quoteImages,
  deleteQuoteImage: (state) => state.deleteQuoteImage,
  dashboardData: (state) => state.dashboardData,
  QRData: (state) => state.QRData,
  inProgressJobs: (state) => state.inProgressJobs,
  completedJobs: (state) => state.completedJobs,
  jobDetail: (state) => state.jobDetail,
  bookingDiagnosisItems: (state) => state.bookingDiagnosisItems,
  diagnosisSubmitResponse: (state) => state.diagnosisSubmitResponse,
  diagnosisUpdateResponse: (state) => state.diagnosisUpdateResponse,
  postUnitResponse: (state) => state.postUnitResponse,
  bindUnitResponse: (state) => state.bindUnitResponse,
  collectDataResponse: (state) => state.collectDataResponse,
  updateCollectDataResponse: (state) => state.updateCollectDataResponse,
  updateJobStatusResponse: (state) => state.updateJobStatusResponse,
  resumeJobResponse: (state) => state.resumeJobResponse,
  endJobResponse: (state) => state.endJobResponse,
  resubmitQuoteResponse: (state) => state.resubmitQuoteResponse,
  bookingResponse: (state) => state.bookingResponse,
  storeChecksResponse: (state) => state.storeChecksResponse,
  bookingNotes: (state) => state.bookingNotes,
  markAsCompleteObject: (state) => state.markAsCompleteObject,
  partsDetails: (state) => state.partsDetails,
  unitsList: (state) => state.unitsList,
  initialChecksList: (state) => state.initialChecksList,
  consumerMembers: (state) => state.consumerMembers,
  equipmentChecksList: (state) => state.equipmentChecksList,
  bookingServices: (state) => state.bookingServices,
  bookingParts: (state) => state.bookingParts,
  bookingDiagnosisOptions: (state) => state.bookingDiagnosisOptions,
  getDiagnosisOptions: (state) => state.getDiagnosisOptions,
  allDiagnosisOptions: (state) => state.allDiagnosisOptions,
  markAsCompleteResponse: (state) => state.markAsCompleteResponse,
  preChecksDetail: (state) => state.preChecksDetail,
  specialParts: (state) => state.specialParts,
  summaryDetail: (state) => state.summaryDetail,
  preChecksStore: (state) => state.preChecksStore,
  preConfig: (state) => state.preConfig,
  config: (state) => state.config,
  services: (state) => state.services,
  bookingConverted: (state) => state.bookingConverted,
  bookingDocs: (state) => state.bookingDocs,
  removeBookingDocs: (state) => state.removeBookingDocs,
  deleteNoteResponse: (state) => state.deleteNoteResponse,
  addNoteResponse: (state) => state.addNoteResponse,
  componentList: (state) => state.componentList,
  waiveTradeCallFee: (state) => state.waiveTradeCallFee,
  resubmitQuote: (state) => state.resubmitQuote,
  maintenanceBannerData: (state) => state.maintenanceBannerData,
  protectionPlans: (state) => state.protectionPlans,
  protectionPlanDetails: (state) => state.protectionPlanDetails,
  cartCountResponse: (state) => state.cartCountResponse,
  cartDetails: (state) => state.cartDetails,
  cartUpdated: (state) => state.cartUpdated,
  consumerDetails: (state) => state.consumerDetails,
  consumerAddresses: (state) => state.consumerAddresses,
  consumerBindCartResponse: (state) => state.consumerBindCartResponse,
  cartCheckoutResponse: (state) => state.cartCheckoutResponse,
  protectionPlanSalesListing: (state) => state.protectionPlanSalesListing,
  billingTransactionListing: (state) => state.billingTransactionListing,
  paymentCardListing: (state) => state.paymentCardListing,
  commissionsList: (state) => state.commissionsList,
  deleteAddressResponse: (state) => state.deleteAddressResponse,
  formattedAddress: (state) => state.formattedAddress,
  consumerAddressStoreResponse: (state) => state.consumerAddressStoreResponse,
  addConsumerResponse: (state) => state.addConsumerResponse,
  salesPlanDetails: (state) => state.salesPlanDetails,
  companyReferalCode: (state) => state.companyReferalCode,
  resendCodeResponse: (state) => state.resendCodeResponse,
  updateStatusResponse: (state) => state.updateStatusResponse,
  signOutResponse: (state) => state.signOutResponse,
  notificationResponse: (state) => state.notificationResponse,
  notificationCountResponse: (state) => state.notificationCountResponse,
  searchResults: (state) => state.searchResults,
  resetAuthResponse: (state) => state.resetAuthResponse,
  resetResendCodeResponse: (state) => state.resetResendCodeResponse,
  resetVerifyResponse: (state) => state.resetVerifyResponse,
  resetPasswordResponse: (state) => state.resetPasswordResponse,
  quoteItems: (state) => state.quoteItems,
  shareProtectionPlanData: (state) => state.shareProtectionPlanData,
  sendProtectionPlanURLCallBack: (state) => state.sendProtectionPlanURLCallBack,
  protectionPlanBundle: (state) => state.protectionPlanBundle,
  protectionPlanBundleAddons: (state) => state.protectionPlanBundleAddons,
  protectionPlanBundleDetailsCallBack: (state) => state.protectionPlanBundleDetailsCallBack,
  cartValidate: (state) => state.cartValidate,
  removeProtectionCartData: (state) => state.removeProtectionCartData,
  selectedProtectionPlan: (state) => state.selectedProtectionPlan,
  bundleQuantityUpdated: (state) => state.bundleQuantityUpdated,
  shareProtectionPlans: (state) => state.shareProtectionPlans,
  shareProtectionPlanURL: (state) => state.shareProtectionPlanURL,
  sendProtectionPlanURLResponse: (state) => state.sendProtectionPlanURLResponse,
  previousEvaluation: (state) => state.previousEvaluation,
  previousEvaluationResponse: (state) => state.previousEvaluationResponse,
  createInvoiceResponse: (state) => state.createInvoiceResponse,
  invoiceDetail: (state) => state.invoiceDetail,
  quoteCheckoutResponse: (state) => state.quoteCheckoutResponse,
  notesDataResponse: (state) => state.notesDataResponse,
  signaturePaymentLinkResponse: (state) => state.signaturePaymentLinkResponse,
  paymentLinkCheckoutResponse: (state) => state.paymentLinkCheckoutResponse,
  sideMenuData: (state) => state.sideMenuData,
  userAccountDetails: (state) => state.userAccountDetails,
  uploadMediaResponse: (state) => state.uploadMediaResponse,
  internalCheckoutResponse: (state) => state.internalCheckoutResponse,
  termsAndConditionsResponse: (state) => state.termsAndConditionsResponse,
  affiliateList: (state) => state.affiliateList,
  affiliateDetails: (state) => state.affiliateDetails,
  updateAffiliateResponse: (state) => state.updateAffiliateResponse,
  passwordResetResponse: (state) => state.passwordResetResponse,
  addonPlanDetails: (state) => state.addonPlanDetails,
  connectivityCheckDetails: (state) => state.connectivityCheckDetails,
  connectivityInitDetails: (state) => state.connectivityInitDetails,
  comissionSummary: (state) => state.comissionSummary,
  stripDisconnect: (state) => state.stripDisconnect,
  stripLogin: (state) => state.stripLogin,
  stripConnect: (state) => state.stripConnect,
  updatePrivacyPolicyDetails: (state) => state.updatePrivacyPolicyDetails,
  updateContractorAgreementDetails: (state) => state.updateContractorAgreementDetails,
  affiliateConfig: (state) => state.affiliateConfig,
  updatePasswordResponse: (state) => state.updatePasswordResponse,
  contactUsResponse: (state) => state.contactUsResponse,
  requestOtpResponse: (state) => state.requestOtpResponse,
  userRegisterResponse: (state) => state.userRegisterResponse,
  userVerifyResponse: (state) => state.userVerifyResponse,
  consumerCartUpdateResponse: (state) => state.consumerCartUpdateResponse,
  cartModalState: (state) => state.cartModalState,
  purchaseCancelValidateResponse: (state) => state.purchaseCancelValidateResponse,
  cardDefaultResponse: (state) => state.cardDefaultResponse,
  cardDeleteResponse: (state) => state.cardDeleteResponse,
  purchasePlanCancelResponse: (state) => state.purchasePlanCancelResponse,
  socialUserResponse: (state) => state.socialUserResponse,
  addCreditCardResponse: (state) => state.addCreditCardResponse,
  shortenUrlResponse: (state) => state.shortenUrlResponse,
  clientIdentifierResponse: (state) => state.clientIdentifierResponse,
  checkoutTotalResponse: (state) => state.checkoutTotalResponse,
  bindPromoCodeResponse: (state) => state.bindPromoCodeResponse,
  sidebarCollapsedState: (state) => state.sidebarCollapsedState,
  claimConfig : (state) => state.claimConfig,
  claimAgreements: (state) => state.claimAgreements,
  agreementAddresses: (state) => state.agreementAddresses,
  agreementDetails: (state) => state.agreementDetails,
  claimResponse: (state) => state.claimResponse,
  unbindPromoCodeResponse: (state) => state.unbindPromoCodeResponse,
  workOrderListing: (state) => state.workOrderListing,
  workOrderDetailResponse: (state) => state.workOrderDetailResponse,
  cancelClaimReasons: (state) => state.cancelClaimReasons,
  cancelClaimResponse: (state) => state.cancelClaimResponse,
  paymentRetryObject: (state) => state.paymentRetryObject,
  paymentRetryResponse: (state) => state.paymentRetryResponse,
  ratingReviewConfigResponse: (state) => state.ratingReviewConfigResponse,
  ratingReviewResponse: (state) => state.ratingReviewResponse,
  claimResheduleResponse: (state) => state.claimResheduleResponse,
  userFailedResponse: (state) => state.userFailedResponse,
  failedInvoices: (state) => state.failedInvoices,
  paymentCollectResponse : (state) => state.paymentCollectResponse,
  paymentCollectFailResponse  : (state) => state.paymentCollectFailResponse,
};

// actions
const actions = {


  
  async paymentCollect({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    commit("storePaymentCollectFail", "");

    await axios
      .post("/bundles/payment/collect", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {

          commit("storePaymentCollect", res.data.body);
        } else {
          commit("storePaymentCollectFail", res.data.message);

        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getFailedInvoices({ commit }, params) {
    startLoader("");

    commit("apiCallback", true);
    await axios
      .get("/bundles/payment/failed-invoices", { params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeFailedinvoices", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },


  async getAgreementAddress({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/claims/agreements/addresses", { params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {

          commit("storeAgreementAddress", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async saveClaim({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/claims/store", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeClaimResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getAgreementDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/claims/agreements/show", { params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {

          commit("storeAgreementDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getClaimAgreements({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/claims/agreements", { params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {

          commit("storeClaimAgreements", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getClaimConfig({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/claims/config")
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {

          commit("storeClaimConfig", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },


  // affiliates/config
  async getAffiliateConfig({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/microservices/affiliates/config", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {

          commit("storeAffiliateConfig", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },


  async stripeConnect({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/stripe/connect", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          let data = {
            "message": res.data.message,
            "sttaus": res.data.status
          }
          commit("storeStripeConnect", data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },



  async stripeLoginConnect({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/stripe/connect/login", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          // let data = {
          //   "message" : res.data.message,
          //   "sttaus" : res.data.status
          // }
          commit("storeStripeLogin", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },


  async stripeDsiconnect({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/stripe/connect/disconnect", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          let data = {
            "message": res.data.message,
            "sttaus": res.data.status
          }
          commit("storeStripeDisconnect", data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },


  async setSelectedProtectionPlan({ commit }, params) {

    setTimeout(() => {
      commit("selectedProtectionPlanState", params);

    }, 50);

  },

  async getComissionSummary({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/microservices/plans/commissions/my-happy-home/summary", params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("storeComissionSummary", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async getSideMenu({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .get("/menu/items", { params: params })
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeSideMenu", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },


  async removeProtectionItemCart({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .delete("/cart/items/remove", { params: params })
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("removeProtectionCart", res.data.body);
          //   toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async validateCart({ commit }, params) {

    commit("storeValidateCart", {
      validation_passed: 1
    });

    // if (!params.is_hide) startLoader();
    // commit("apiCallback", true);
    // await axios
    //   .post("/microservices/plans/cart/validate-item", params)
    //   .then((res) => {
    //     if (!params.is_hide) hideLoader();
    //     if (res.data.status == true) {
    //       commit("storeValidateCart", res.data.body);
    //       //   toast.success(res.data.message);
    //     } else {
    //       toast.error(res.data.message);
    //     }
    //     commit("apiCallback", false);
    //   })
    //   .catch((err) => {
    //     if (!params.is_hide) hideLoader();

    //     commit("apiCallback", false);
    //   });
  },



  async getProtectionPlanBundleDetails({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post(`/microservices/plans/bundles/detail/${params.id}`, params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeProtectionPlanBundleDetailsData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },


  async getProtectionPlansBundle({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post("/bundles/list", params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeProtectionPlansBundle", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async getProtectionPlansBundleAddons({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post("/bundles/list", params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeProtectionPlansBundleAddons", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },



  async sendProtectionPlanURL({ commit }, params) {
    commit("savesendProtectionPlanData", false);
    startLoader("");
    await axios
      .post("/microservices/url/send", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("savesendProtectionPlanData", res.data.status);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);

      })
      .catch((err) => {
        hideLoader("");
        commit("apiCallback", false);

        console.log("error", err);
      });
  },


  async shareProtectionPlan({ commit }, params) {
    commit("apiCallback", true);
    startLoader("");
    await axios
      .post("/microservices/url/get-url", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveshareProtectionPlan", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);

      })
      .catch((err) => {
        hideLoader("");
        commit("apiCallback", false);

        console.log("error", err);
      });
  },

  async getQuoteItemsPartner({ commit }, params) {
    commit("apiCallback", true);
    startLoader("");
    await axios
      .post("/manual-quote/partner/items/list", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveQuoteItems", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);

      })
      .catch((err) => {
        hideLoader("");
        commit("apiCallback", false);

        console.log("error", err);
      });
  },

  async getQuoteItems({ commit }, params) {
    commit("apiCallback", true);
    startLoader("");
    await axios
      .get("/manual-quote/items/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveQuoteItems", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);

      })
      .catch((err) => {
        hideLoader("");
        commit("apiCallback", false);

        console.log("error", err);
      });
  },



  async getMaintenanceBannerData({ commit }, params) {
    startLoader("");
    await axios
      .get("/notification-banner", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveMaintenanceBannerData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },


  async resubmitManualQuote({ commit }, params) {
    startLoader("");
    await axios
      .post("manual-quote/partner/resubmit-quote", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveresubmitManualQuote", true);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async waiveTradeCall({ commit }, params) {
    startLoader("");
    await axios
      .post("manual-quote/partner/trade-call-fee/waive", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveWaiveTradeCallFee", true);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async getComponentList({ commit }, params) {
    startLoader("");
    await axios
      .get("parts/component-list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveComponentList", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },




  async bookingDocumentDelete({ commit }, params) {
    startLoader("");
    await axios
      .delete("bookings/document/other/remove", { params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("removeBookingDocument", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async deleteBookingNote({ commit }, params) {
    startLoader("");
    await axios
      .post("bookings/notes/delete/" + params.booking_id, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveDeleteNotes", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async addBookingNote({ commit }, params) {
    startLoader("");
    await axios
      .post("bookings/notes/store/" + params.booking_id, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveAddNotes", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async uploadBookingImage({ commit }, params) {
    startLoader("");

    await axios
      .post("bookings/document/other/upload", params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        hideLoader("");

        if (res.data.status == true) {
          commit("saveBookingImage", res.data.body);
        } else {
          commit("saveBookingImage", res.data);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {

      });
  },

  async getBookingDocs({ commit }, params) {
    startLoader("");
    await axios
      .get("bookings/document/other/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveBookingDocs", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async convretToBooking({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("appointments/convert/booking", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("bookingConvert", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getServices({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("services", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveServices", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async getUnitList({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("units-new/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveUnitsInfo", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getBookingParts({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("parts/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveBookingParts", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getBookingDiagnosisOptions({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/diagnosis/options", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveBookingDiagnosisOptions", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getBookingServices({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/diagnosis/revamp/services", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveBookingServices", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getEquipmentChecks({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/diagnosis/revamp/options", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveEquipmentChecks", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getConsumerMembers({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("consumer/member/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          if (res.data.body.length <= 0) {
            toast.error("no members found");
          }
          commit("saveConsumerMembers", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getInitialChecks({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/diagnosis/revamp/initial-checks", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveInitialChecks", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getDiagnosisOption({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/diagnosis/draft/get", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveDiagnosisOptions", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getAllDiagnosisOption({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/diagnosis/draft/all", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveAllDiagnosisOptions", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getSummaryDetail({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/summary/calculate", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveSummaryDetail", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getPreChecksDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/submit/pre-checks/detail", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("savePreChecksDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getSpecialParts({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/bookings/diagnosis/special-parts", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveSpecialParts", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async storePreChecksDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/submit/pre-checks/store", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("savePreChecksResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getPreConfig({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("units-new/pre-config", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("savePreConfig", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getConfig({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("units-new/config", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveConfig", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getpartsDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/diagnosis/summary/parts", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("savepartsDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getBookingNotes({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/notes", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveBookingNotes", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getMarkAsCompleteObject({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/mark-as-completed/data", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveMarkAsCompleteObject", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async diagnosisSubmit({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/submit", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveDiagnosisSubmit", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async diagnosisUpdate({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/update", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveDiagnosisUpdate", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getBookingDetail({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/show", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveJobDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getBookingDiagnosisItems({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/items", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveBookingDiagnosisItems", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getBookingList({ commit }, params) {
    let status = params["status"];
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("bookings/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          if (status == 8) {
            commit("saveInProgressJobs", res.data.body);
          } else {
            commit("saveCompletedJobs", res.data.body);
          }
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getQRData({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("qrCode/job-detail", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveQRData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getDashboardData({ commit }) {
    startLoader("");

    let obj = {};
    obj["is_tech_web"] = "1";
    commit("apiCallback", true);
    await axios
      .post("side-menu", obj)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveDashboardData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async postUnitDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("units-new/update", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("postUnitDetailResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async bindUnit({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("units/bind", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveBindUnit", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async postCollectData({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/submit/collect-data", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveCollectData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async updateCollectData({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/update/collect-data", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveUpdateCollectData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async updateJobStatus({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/status", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveUpdateJobStatus", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async resumeJob({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/status/resume", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveResumeJob", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async endJob({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/status/complete", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveEndJob", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async resubmitQuote({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/decline/re-submit", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveResubmitQuote", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getBookingDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/show-web", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("saveBookingResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async storeChecks({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("bookings/diagnosis/draft/store", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeChecksResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async proLogin({ commit }, params) {
    startLoader("");
    commit("setSilentLogin", true);
    await axios
      .post("web-auth/login", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUserObject", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("setSilentLogin", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("setSilentLogin", false);
      });
  },

  async silentLogin({ commit }, params) {
    startLoader("silentLogin");
    commit("setSilentLogin", true);
    await axios
      .post("silent-login", params)
      .then((res) => {
        hideLoader("silentLogin");
        if (res.data.status == true) {
          localStorage.setItem('user', JSON.stringify(res.data.body))
          localStorage.setItem('isSilentLogin', true)

          commit("saveUserObject", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("setSilentLogin", false);
      })
      .catch((err) => {
        hideLoader("silentLogin");
        console.log("error", err);
        commit("setSilentLogin", false);
      });
  },

  async setSSOLogin({ commit }, params) {
    startLoader("ssoLogin");
    commit("apiCallback", true);
    await axios
      .post("/auth/web/verify", params)
      .then((res) => {
        hideLoader("ssoLogin");
        if (res.data.status == true) {
          commit("saveUserObject", res.data.body);
        } else {
          toast.error(res.data.message);
          commit("saveUserObjectFailed", res.data);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        console.log(err);
        
        hideLoader("ssoLogin");
        commit("apiCallback", false);
      });
  },

  async getAppointmentDetailsAPICall({ commit }, params) {
    startLoader("getAppointmentDetailsAPICall");
    commit("setAppointmentDetails", true);
    await axios
      .post("/appointments/view", params)
      .then((res) => {
        hideLoader("getAppointmentDetailsAPICall");
        if (res.data.status == true) {
          commit("saveApptDetailObject", res.data.body);
          commit("setAppointmentDetails", false);

        } else {
          commit("setAppointmentDetails", true);

          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("getAppointmentDetailsAPICall");

        commit("setAppointmentDetails", false);
      });
  },

  //pro/company/info
  async getCompanyInfo({ commit }, params) {
    startLoader("getCompanyInfo");
    commit("setCompanyInfo", true);
    await axios
      .get("/company/info", params)
      .then((res) => {
        hideLoader("getCompanyInfo");
        if (res.data.status == true) {
          commit("saveCompanyInfo", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("setCompanyInfo", false);
      })
      .catch((err) => {
        hideLoader("getCompanyInfo");

        commit("setCompanyInfo", false);
      });
  },

  //pro/manual-quote/partner/equipments

  async getEquipmentInfo({ commit }, params) {
    startLoader("getEquipmentInfo");
    commit("setEquipmentInfo", true);
    await axios
      .get("/manual-quote/partner/equipments", { params: params })
      .then((res) => {
        hideLoader("getEquipmentInfo");
        if (res.data.status == true) {
          commit("saveEquipmentInfo", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("setEquipmentInfo", false);
      })
      .catch((err) => {
        hideLoader("getEquipmentInfo");

        commit("setEquipmentInfo", false);
      });
  },

  //Hvac Equipment Info

  async getHvacEquipmentInfo({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .get("/manual-quote/partner/units/detail", { params: params })
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("saveHvacEquipmentInfo", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  //get Hvac Config

  async getHvacConfig({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .get("/manual-quote/partner/units/config", { params: params })
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("saveHvacConfig", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  //pro/manual-quote/partner/units/upsert

  async HvacEquipmentStore({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/partner/units/upsert", params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("saveHvacEquipmentInfoStore", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  //pro/manual-quote/partner/equipments/store

  async equipmentInfoStore({ commit }, params) {
    startLoader("equipmentInfoStore");
    commit("setEquipmentInfoStore", true);
    await axios
      .post("/manual-quote/partner/equipments/store", params)
      .then((res) => {
        hideLoader("equipmentInfoStore");
        if (res.data.status == true) {
          commit("saveEquipmentInfoStore", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("setEquipmentInfoStore", false);
      })
      .catch((err) => {
        hideLoader("equipmentInfoStore");

        commit("setEquipmentInfoStore", false);
      });
  },

  //pro/appointments/en-route

  async markAsEnrouteAPICall({ commit }, params) {
    startLoader("markAsEnrouteAPICall");
    commit("setAppointmentAction", true);
    await axios
      .put("/appointments/en-route", params)
      .then((res) => {
        hideLoader("markAsEnrouteAPICall");
        if (res.data.status == true) {
          commit("saveApptointmentActionEnroute", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("setAppointmentAction", false);
      })
      .catch((err) => {
        hideLoader("markAsEnrouteAPICall");

        commit("setAppointmentAction", false);
      });
  },

  //pro/appointments/arrived

  async markAsArrivedAPICall({ commit }, params) {
    startLoader("markAsArrivedAPICall");
    commit("setAppointmentAction", true);
    await axios
      .put("/appointments/arrived", params)
      .then((res) => {
        hideLoader("markAsArrivedAPICall");
        if (res.data.status == true) {
          commit("saveApptointmentActionArrived", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("setAppointmentAction", false);
      })
      .catch((err) => {
        hideLoader("markAsArrivedAPICall");

        commit("setAppointmentAction", false);
      });
  },

  //pro/appointments/uq/create
  async appointmentCreate({ commit }, params) {
    startLoader("appointmentCreate");
    commit("setAppointmentAction", true);
    await axios
      .post("/appointments/uq/create", params)
      .then((res) => {
        hideLoader("appointmentCreate");
        if (res.data.status == true) {
          commit("saveApptointmentCreatelObject", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("setAppointmentAction", false);
      })
      .catch((err) => {
        hideLoader("appointmentCreate");

        commit("setAppointmentAction", false);
      });
  },

  //Notes Update
  async updateNote({ commit }, params) {
    startLoader("updateNote");
    commit("apiCallback", true);
    await axios
      .put(`/manual-quote/notes/update/${params.id}`, params)
      .then((res) => {
        hideLoader("updateNote");
        if (res.data.status == true) {
          commit("notesData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("updateNote");

        commit("apiCallback", false);
      });
  },

  //Notes Add
  async addNote({ commit }, params) {
    startLoader("addNote");
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/update-notes", params)
      .then((res) => {
        hideLoader("addNote");
        if (res.data.status == true) {
          commit("notesData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("addNote");

        commit("apiCallback", false);
      });
  },

  async addManualQuoteNote({ commit }, params) {
    startLoader("addNote");
    commit("apiCallback", true);
    await axios
      .post(`/appointments/internal-notes/${params.id}/store`, params)
      .then((res) => {
        hideLoader("addNote");
        if (res.data.status == true) {
          commit("notesData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("addNote");
        alert(err);
        commit("apiCallback", false);
      });
  },

  //Notes Delete
  async deleteNote({ commit }, params) {
    startLoader("deleteNote");
    commit("apiCallback", true);
    await axios
      .delete(`/manual-quote/notes/delete/${params.id}`)
      .then((res) => {
        hideLoader("deleteNote");
        if (res.data.status == true) {
          commit("notesData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("deleteNote");

        commit("apiCallback", false);
      });
  },

  //pro/partner/parts/categories
  async getPartCategories({ commit }, params) {
    startLoader("getPartCategories");
    commit("apiCallback", true);
    await axios
      .get("/partner/parts/categories", { params: params })
      .then((res) => {
        hideLoader("getPartCategories");
        if (res.data.status == true) {
          commit("savePartCategories", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("getPartCategories");

        commit("apiCallback", false);
      });
  },

  //pro/partner/parts/list

  async getPartList({ commit }, params) {
    startLoader("getPartList");
    commit("apiCallback", true);
    await axios
      .get(params.url, { params: params.params })
      .then((res) => {
        hideLoader("getPartList");
        if (res.data.status == true) {
          commit("savePartList", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("getPartList");

        commit("apiCallback", false);
      });
  },

  // Store Quote Items
  async postQuoteData({ commit }, params) {
    startLoader("postQuoteData");
    commit("apiCallback", true);
    await axios
      .post(params.url, params.params)
      .then((res) => {
        hideLoader("postQuoteData");
        if (res.data.status == true) {
          commit("storeQuoteItems", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("postQuoteData");

        commit("apiCallback", false);
      });
  },

  // Store Quote Detail
  async getQuoteDetail({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .get("/manual-quote/detail", { params: params })
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeQuoteDetail", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  // Pause Quote
  async pauseQuote({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/status/in-progress", params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("storeQuoteDetail", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  // Complete Quote
  async completeQuote({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/status/complete", params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("storeQuoteDetail", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  // Get Quote Summary
  async getQuoteSummary({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post(params.url, params.params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("storeQuoteSummary", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  //pro/manual-quote/partner/update
  async postQuoteSummary({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post(params.url, params.params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("updateQuoteSummary", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  //pro/manual-quote/get-notes

  async getNotes({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .get("/manual-quote/get-notes", { params: params })
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("storeNotesData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  async getManualQuotesNotes({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .get(`/appointments/internal-notes/${params.id}/list`)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("storeNotesData", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();
        alert(err);
        commit("apiCallback", false);
      });
  },

  //pro/manual-quote/status/canceled
  async postCancelQuote({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/status/canceled", params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("storeQuoteDetail", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  updateQuoteItems(context, quote) {
    context.commit("storeQuoteDetail", quote);
  },

  clearState(context) {
    context.commit(" storeQuoteSummary", null);
  },

  setCommponent({ commit }, data) {
    commit("updateComponentState", data);
  },

  async appointmentCancel({ commit }, params) {
    commit("apiCallback", true);
    await axios
      .put("/appointments/cancel", params)
      .then((res) => {
        if (res.data.status == true) {
          commit("saveApptointmentCancel", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

        commit("apiCallback", false);
      });
  },

  async checkoutAcknowledge({ commit }, params) {
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/checkout/acknowledgment", params)
      .then((res) => {
        if (res.data.status == true) {
          commit("checkoutResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

        commit("apiCallback", false);
      });
  },

  async getQRCode({ commit }, params) {
    startLoader();

    commit("apiCallback", true);

    await axios
      .get("/qrCode/job-detail", { params: params })
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          console.log("updated rewpoe", res.data.body);
          commit("qrResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

        hideLoader();
        commit("apiCallback", false);
      });
  },

  async postMarkAsComplete({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/bookings/status/mark-as-complete", params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("savePostMarkAsComplete", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  async startQuote({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/status/start", params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("storeQuoteDetail", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  async getReasons({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .get(`/manual-quote/partner/cancel/reason/${params.id}`)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("cancelReason", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  async sendQuoteToEmail({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/send", params)
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("emailQuoteResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

        commit("apiCallback", false);
      });
  },

  async uploadQuoteImage({ commit }, params) {

    startLoader();
    commit("apiCallback", true);
    await axios
      .post("/manual-quote/document/upload", params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("quoteImageUploaded", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  async getQuoteImages({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .get("/manual-quote/document/list", { params: params })
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("quoteImages", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  async deleteQuoteImages({ commit }, params) {
    startLoader();
    commit("apiCallback", true);
    await axios
      .delete("manual-quote/document/remove", { params })
      .then((res) => {
        hideLoader();
        if (res.data.status == true) {
          commit("deleteQuoteImage", true);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader();

        commit("apiCallback", false);
      });
  },

  updateDeletedQuoteImages(context) {
    context.commit("deleteQuoteImage", false);
  },


  async getProtectionPlans({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post("/microservices/plans/list", params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeProtectionPlans", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async getProtectionPlanDetails({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post(`/microservices/plans/detail/${params.id}`, params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeProtectionPlanDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async getCartCount({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .get("/cart/detail", { params: params })
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeCartCount", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async getUserAccountDetails({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post("/profile/connected-account", params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeUserAccountDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async getCartDetails({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .get("/cart/items/list", { params: params })
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          let data = res.data.body
          data['items'] = []
          // This code is moving bundle data from bundle key to item key
          // Move items of bundles where is_single_plan_bundle = 1
          const movedItems = data.bundles
            .filter(bundle => bundle.is_single_plan_bundle === 1)
            .map(bundle => {
              const item = bundle.items[0]; // because single plan bundle has only one item

              return {
                ...item,
                item_quantity: bundle.bundle_quantity,
                item_total_amount: item.item_unit_price * bundle.bundle_quantity,
                is_single_plan_bundle: bundle.is_single_plan_bundle,// ✅ move this key
                bundle_id: bundle.bundle_id
              };
            });

          // Add to root items array
          data.items.push(...movedItems);
          // Remove those bundles from bundles list
          data.bundles = data.bundles.filter(bundle => bundle.is_single_plan_bundle !== 1);
          console.log("bundles -- >", data);
          commit("storeCartDetails", data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        console.log(err);
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },



  async upsertCart({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    commit("updateBundleQuantity", false)
    await axios
      .post("/cart/items/upsert", params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {

          commit("storeUpsertCart", res.data.body);
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async getConsumerDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("consumer/get-detail", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeConsumerDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async getConsumerAddresses({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("consumer/addresses/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeConsumerAddresses", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async consumerBindCart({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("microservices/plans/cart/consumer/bind", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeConsumerBindCart", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async cartCheckout({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/microservices/plans/cart/checkout", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeCartCheckout", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },



  async getPurshaseListing({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/bundles/purchase-history/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeProtectionPlanSalesListing", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async getCommissionsList({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/microservices/plans/commissions/my-happy-home/list", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeCommissionsList", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async deleteAddress({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .delete(`/consumer/addresses/destroy/${params.id}`)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          toast.success(res.data.message);
          commit("storeDeleteAddressResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async getFormattedAddress({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get(`/formatted/address`, { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeFormattedAddress", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },



  async addConsumerAddress({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/consumer/addresses/store`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeAddConsumerAddress", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async storeConsumer({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/consumer/store`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeConsumerResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async getPurchasePlanDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get(`/bundles/purchase-history/show/${params.id}`, { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePurchasePlanDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },



  async checkCompanyReferalCode({ commit }, params) {
    // startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/enrollment/check-referral`, params)
      .then((res) => {
        // hideLoader("");
        // if (res.data.status == true) {
        //   commit("storeCompanyReferalCode", res.data.body);
        // } else {
        //   toast.error(res.data.message);
        // }
        commit("storeCompanyReferalCode", res.data);
        commit("apiCallback", false);
      })
      .catch((err) => {
        // hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async userRegister({ commit }, params) {
    startLoader("");
    await axios
      .post("/auth/register", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUserRegister", res.data);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        toast.error(err.response?.data?.message ?? "Something went wrong.");
        console.log("error", err);
      });
  },

  async resendCode({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/web-auth/resend", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeResendCode", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async updateUser({ commit }, params) {
    startLoader("");

    await axios
      .post("/profile/update", params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUpdatedUser", res.data.body);
          let user = JSON.parse(localStorage.getItem('user')) ?? null
          user.user = res.data.body
          commit("storeUserObject", user);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        toast.error(err.response?.data?.message ?? "Something went wrong.");
        console.log("error", err);
      });
  },

  async removeUserImage({ commit }, params) {
    startLoader("");

    await axios
      .delete("/profile/image/remove", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          toast.success(res.data.message)
          commit("storeUpdatedUser", res.data.body);
          let user = JSON.parse(localStorage.getItem('user')) ?? null
          user.user = res.data.body
          commit("storeUserObject", user);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async updateStatus({ commit }, params) {
    startLoader("");

    await axios
      .post("/profile/online/status", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUpdateStatus", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async getProfile({ commit }, params) {
    if (params.is_show) startLoader();

    await axios
      .get("/profile/me", { params: params })
      .then((res) => {
        if (params.is_show) hideLoader();
        if (res.data.status == true) {
          let user = JSON.parse(localStorage.getItem('user')) ?? null
          user['user'] = res.data.body
          commit("storeUserObject", user);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        if (params.is_show) hideLoader();
        console.log("error", err);
      });
  },

  async signOut({ commit }, params) {
    startLoader("");
    commit("storeSignOut", null);
    await axios
      .post("/auth/logout", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeSignOut", true);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },



  async fetchNotifications({ commit }, params) {
    // startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/notifications/list`, params)
      .then((res) => {
        // hideLoader("");
        if (res.data.status == true) {
          commit("storeNotificationResponse", res.data);
          commit("storeNotificationCountResponse", null);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        // hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async unreadNotificationsCount({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/notifications/unread`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeNotificationCountResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getSearchResults({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/search/protectionPlans`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeSearchResults", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async resetAuth({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/reset-password/authenticate`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeResetAuthResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async resetResendCode({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/reset-password/resend`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeResetResendCodeResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async resetVerify({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/reset-password/verify`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeResetVerifyResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async resetPassword({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/reset-password/reset`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeResetPasswordResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getShareProtectionPlans({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post(`/microservices/plans/share-plan`, params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeShareProtectionPlans", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getPreviousEvaluation({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/bookings/diagnosis/revamp/re-evaluate/options", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePreviousEvaluation", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getShareProtectionPlanURL({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post(`/microservices/plans/share-plan/generate-url`, params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeShareProtectionPlanURL", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
      });
  },

  async postPreviousEvaluation({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/bookings/diagnosis/revamp/re-evaluate/store`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePreviousEvaluationResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
      });
  },

  async sendShareProtectionPlanURL({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post(`/microservices/plans/share-plan/send-url`, params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeSendProtectionPlanURL", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async createInvoice({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .post(`/invoice/create`, params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeCreateInvoiceResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },


  async getInvoiceDetail({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .get(`/invoice/detail/${params.invoice_id}`, { params: params })
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeInvoiceDetail", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async postCheckout({ commit }, params) {
    startLoader("");

    await axios
      .post("checkout", params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeCheckoutResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

      });
  },

  async apptServiceUpdate({ commit }, params) {
    startLoader("");
    await axios
      .post("/services/update", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          // commit("storeCheckoutResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

      });
  },

  async uploadSignaturePaymentLink({ commit }, params) {
    startLoader("");

    await axios
      .post(`invoice/upload-signature/${params.get('invoice_id')}`, params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeSignaturePaymentLinkResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

      });
  },

  async paymentLinkCheckout({ commit }, params) {
    startLoader("");

    await axios
      .post(`invoice/checkout/session`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePaymentLinkCheckoutResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

      });
  },

  async uploadMedia({ commit }, params) {
    startLoader("");

    await axios
      .post(`/media/upload`, params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUploadMediaResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

      });
  },


  async internalCheckout({ commit }, params) {
    startLoader("");

    await axios
      .post(`/cart/checkout`, params)
      .then((res) => {
        hideLoader("");

        if (res.data.status == true) {
          commit("storeInternalCheckoutResponse", res.data);
        } else {
          commit("storeInternalCheckoutResponse", res.data);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
         hideLoader("");
         commit("storeInternalCheckoutResponse", err.response?.data);
      });
  },

  async getTermsAndConditions({ commit }, params) {
    startLoader("");

    await axios
      .get(`/legal/terms-and-conditions`, { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeTermsAndConditionsResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

      });
  },

  async getTermsAndConditionsCheckout({ commit }, params) {
    startLoader("");

    await axios
      .get(`/legal/checkout-terms-and-conditions`, { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeTermsAndConditionsResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {

      });
  },



  async getAffiliateList({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/microservices/affiliates/list", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeAffiliateList", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async addAffiliate({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/microservices/affiliates/store", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeAffiliateDetails", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async updateAffiliateStatus({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/microservices/affiliates/status/${params.id}`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUpdateAffiliateResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async editAffiliate({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/microservices/affiliates/update/${params.id}`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeAffiliateDetails", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async requestPasswordReset({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`web-auth/password-reset`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePasswordResetResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  resetSate({ commit }) {
    commit("reset_state");
  },

  async getAddonPlanDetails({ commit }, params) {
    if (!params.is_hide) startLoader();
    commit("apiCallback", true);
    await axios
      .get(`/bundles/coverage-detail/${params.id}`, params)
      .then((res) => {
        if (!params.is_hide) hideLoader();
        if (res.data.status == true) {
          commit("storeAddonPlanDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();

        commit("apiCallback", false);
      });
  },

  async getConnectivityCheckDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/stripe/connectivity-check", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeConnectivityCheckDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getConnectivityInitDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/stripe/connectivity-init", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeConnectivityInitDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getUpdateStripeDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/stripe/connectivity-init", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUpdateStripeDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getPrivacyPolicyDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/legal/partner-privacy-policy", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePrivacyPolicyDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async getContractorAgreementDetails({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/legal/partner-privacy-policy", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeContractorAgreementDetails", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },


  async updatePassword({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/profile/password/update", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUpdatePasswordResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async postContactUsForm({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/contact-us/store", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeContactUsResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
        commit("apiCallback", false);
      });
  },

  async requestOtp({ commit }, params) {
    startLoader("");
    await axios
      .post("/auth/request-otp", params)
      .then((res) => {
        hideLoader("");

        if (res.data.status == true) {
          commit("storeRequestOtp", res.data);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        if (!params.is_hide) hideLoader();
      });
  },

  async checkSocialUser({ commit }, params) {
    startLoader("");
    await axios
      .post(`/auth/social/${params.provider}`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeSocialUserResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        if (!params.is_hide) hideLoader();
      });
  },

  async verifyUser({ commit }, params) {
    startLoader("");
    await axios
      .post("/auth/verify", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUserVerify", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async consumerCartUpdate({ commit }, params) {
    startLoader("");
    await axios
      .post("/cart/update/consumer", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeConsumerCartUpdate", res.data.body);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
      });
  },

  async getPurchaseCancelValidation({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/bundles/purchase-history/cancel/validate/${params.id}`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePurchaseCancelValidateResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async purchasePlanCancel({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/bundles/purchase-history/cancel`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePurchasePlanCancelResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getTransactionListing({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/billing/invoices/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeBillingTransactionListing", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getCardListing({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/billing/cards/list", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePaymentCardListing", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getCardDefault({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/billing/cards/make-default`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeCardDefaultResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getCardDelete({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .delete(`/billing/cards`, { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeCardDeleteResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async addCreditCard({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/billing/cards/store`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeAddCreditCardResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getShortenUrl({ commit }, params) {
    // startLoader("");
    commit("apiCallback", true);
    await axios
      .get(`/shorten-url/${params.identifier}`)
      .then((res) => {
        // hideLoader("");
        if (res.data.status == true) {
          commit("storeShortenUrlResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        // hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async updateClientIdentifier({ commit }, params) {
    // startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/existing-cart/update`, params)
      .then((res) => {
        // hideLoader("");
        if (res.data.status == true) {
          commit("storeClientIdentifierResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        // hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getCheckoutTotal({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get(`/cart/prices/total`)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeCheckoutTotalResponse", res.data.body);
                } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },  

  async getWorkOrderListing({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/claims", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeWorkOrderListing", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },


  async bindPromoCode({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/promo-code/bind`,params)
      .then((res) => {
        hideLoader("");
        commit("storeBindPromoCodeResponse", res.data);
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async unbindPromoCode({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/promo-code/un-bind`,params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeUnBindPromoCodeResponse", res.data.body);
                } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getWorkOrderDetail({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get(`/claims/show/${params.id}`)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeWorkOrderDetailResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getPurchaseCancelReasons({ commit } , params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/reason/list",params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeCancelReasons", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getCancelReasons({ commit }) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post("/claims/cancel-reason")
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeCancelReasons", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async cancelClaim({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/claims/cancel/${params.appointment_id}?cancel_reason=${params.cancel_reason}`)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          toast.success(res.data.message);
          commit("storeCancelClaimResponse", res.data);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async eventTrackUpdate({ commit }, params) {
    // startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/cart/track/event`,params)
      .then((res) => {
        // hideLoader("");
        if (res.data.status == true) {
          // toast.success(res.data.message);
          // commit("storeCancelClaimResponse", res.data);
        } else {
          // toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        // hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },  

  async getPaymentRetry({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get("/bundles/payment/retry/show", { params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePaymentRetryObject", res.data.body);
          } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async getRatingReviewConfig({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .get(`/work-orders/feedback/config`,{ params: params })
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storeRatingReviewConfigResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async storePaymentRetry({ commit }, params) {
    startLoader("");
    commit("storePaymentCollectFail", "");

    commit("apiCallback", true);
    await axios
      .post("/bundles/payment/retry/store", params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          commit("storePaymentRetryResponse", res.data.body);
          toast.success(res.data.message);
                  } else {
            commit("storePaymentCollectFail", res.data.message);

        //  toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },

  async postRatingReview({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/work-orders/feedback/store`,params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          toast.success(res.data.message);
          commit("storeRatingReviewResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  },  

  async claimReshedule({ commit }, params) {
    startLoader("");
    commit("apiCallback", true);
    await axios
      .post(`/claims/re-schedule/${params.claimID}`, params)
      .then((res) => {
        hideLoader("");
        if (res.data.status == true) {
          toast.success(res.data.message);
          commit("storeClaimResheduleResponse", res.data.body);
        } else {
          toast.error(res.data.message);
        }
        commit("apiCallback", false);
      })
      .catch((err) => {
        hideLoader("");
        console.log("error", err);
        commit("apiCallback", false);
      });
  }, 

  updateCartModalState({ commit }, data) {
    commit("storeCartModalState", data);
  },

  updateSidebarCollapsed({ commit }, data) {
    commit("storeSidebarCollapsedState", data);
  },
};

// mutations
const mutations = {


  storePaymentCollectFail(state, data) {
    state.paymentCollectFailResponse = data
  },

  storePaymentCollect(state, data) {
    state.paymentCollectResponse = data
  },

  storeFailedinvoices(state, data) {
    state.failedInvoices = data
  },

  storeClaimResponse(state, data) {
    state.claimResponse = data
  },

  storeAgreementDetails(state, data) {
    state.agreementDetails = data
  },

  storeAgreementAddress(state, data) {
    state.agreementAddresses = data
  },

  storeClaimAgreements(state, data) {
    state.claimAgreements = data
  },

  storeClaimConfig(state, data) {
    state.claimConfig = data
  },

  storeAffiliateConfig(state, data) {
    state.affiliateConfig = data
  },

  storeStripeConnect(state, data) {
    state.stripConnect = data
  },

  storeStripeLogin(state, data) {
    state.stripLogin = data
  },

  storeStripeDisconnect(state, data) {
    state.stripDisconnect = data
  },

  storeComissionSummary(state, data) {
    state.comissionSummary = data
  },

  selectedProtectionPlanState(state, data) {
    state.selectedProtectionPlan = data

  },

  removeProtectionCart(state, data) {
    state.removeProtectionCartData = data
  },

  storeProtectionPlansBundle(state, data) {
    state.protectionPlanBundle = data
  },

  storeProtectionPlansBundleAddons(state, data) {
    state.protectionPlanBundleAddons = data
  },

  savesendProtectionPlanData(state, data) {
    state.sendProtectionPlanURLCallBack = data
  },

  saveshareProtectionPlan(state, data) {
    state.shareProtectionPlanData = data
  },

  saveQuoteItems(state, data) {
    state.quoteItems = data
  },

  reset_state(state) {
    state.cartCountResponse = {}
    state.protectionPlans = {}
  },

  saveresubmitManualQuote(state, data) {
    state.resubmitQuote = data;
  },

  saveWaiveTradeCallFee(state, data) {
    state.waiveTradeCallFee = data;
  },

  saveComponentList(state, data) {
    state.componentList = data;
  },

  saveMaintenanceBannerData(state, data) {
    state.maintenanceBannerData = data
  },

  removeBookingDocument(state, data) {
    state.removeBookingDocs = data;
  },

  saveDeleteNotes(state, data) {
    state.deleteNoteResponse = data;
  },

  saveAddNotes(state, data) {
    state.addNoteResponse = data;
  },

  saveBookingDocs(state, data) {
    state.bookingDocs = data;
  },

  bookingConvert(state, data) {
    state.bookingConverted = data;
  },

  saveServices(state, data) {
    state.services = data;
  },


  saveUnitsInfo(state, data) {
    state.unitsList = data;
  },

  saveInitialChecks(state, data) {
    state.initialChecksList = data;
  },

  saveConsumerMembers(state, data) {
    state.consumerMembers = data;
  },

  saveEquipmentChecks(state, data) {
    state.equipmentChecksList = data;
  },

  saveBookingServices(state, data) {
    state.bookingServices = data;
  },

  saveBookingParts(state, data) {
    state.bookingParts = data;
  },

  saveBookingDiagnosisOptions(state, data) {
    state.bookingDiagnosisOptions = data;
  },

  saveDiagnosisOptions(state, data) {
    state.getDiagnosisOptions = data;
  },

  saveAllDiagnosisOptions(state, data) {
    state.allDiagnosisOptions = data;
  },

  savePostMarkAsComplete(state, data) {
    state.markAsCompleteResponse = data;
  },

  savePreChecksDetails(state, data) {
    state.preChecksDetail = data;
  },

  saveSpecialParts(state, data) {
    state.specialParts = data;
  },

  saveSummaryDetail(state, data) {
    state.summaryDetail = data;
  },

  savePreChecksResponse(state, data) {
    state.preChecksStore = data;
  },

  savePreConfig(state, data) {
    state.preConfig = data;
  },

  saveConfig(state, data) {
    state.config = data;
  },

  postUnitDetailResponse(state, data) {
    state.postUnitResponse = data;
  },

  saveBindUnit(state, data) {
    state.bindUnitResponse = data;
  },

  saveCollectData(state, data) {
    state.collectDataResponse = data;
  },

  saveUpdateCollectData(state, data) {
    state.updateCollectDataResponse = data;
  },

  saveUpdateJobStatus(state, data) {
    state.updateJobStatusResponse = data;
  },

  saveResumeJob(state, data) {
    state.resumeJobResponse = data;
  },

  saveEndJob(state, data) {
    state.endJobResponse = data;
  },

  saveResubmitQuote(state, data) {
    state.resubmitQuoteResponse = data;
  },

  saveBookingResponse(state, data) {
    state.bookingResponse = data;
  },

  storeChecksResponse(state, data) {
    state.storeChecksResponse = data;
  },

  saveBookingNotes(state, data) {
    state.bookingNotes = data;
  },

  saveMarkAsCompleteObject(state, data) {
    state.markAsCompleteObject = data;
  },

  savepartsDetails(state, data) {
    state.partsDetails = data;
  },

  saveJobDetails(state, data) {
    state.jobDetail = data;
  },

  saveBookingDiagnosisItems(state, data) {
    state.bookingDiagnosisItems = data;
  },

  saveDiagnosisSubmit(state, data) {
    state.diagnosisSubmitResponse = data;
  },

  saveDiagnosisUpdate(state, data) {
    state.diagnosisUpdateResponse = data;
  },

  deleteQuoteImage(state, deleteQuoteImage) {
    state.deleteQuoteImage = deleteQuoteImage;
  },

  quoteImages(state, quoteImages) {
    state.quoteImages = quoteImages;
  },

  saveApptointmentCancel(state, cancelAppointment) {
    state.cancelAppointment = cancelAppointment;
  },

  saveEquipmentInfoStore(state, saveEquipmentInfoStore) {
    state.saveEquipmentInfoStore = saveEquipmentInfoStore;
  },

  saveHvacEquipmentInfoStore(state, saveHvacEquipmentInfoStore) {
    state.saveHvacEquipmentInfoStore = saveHvacEquipmentInfoStore;
  },

  setEquipmentInfoStore(state, setEquipmentInfoStore) {
    state.setEquipmentInfoStore = setEquipmentInfoStore;
  },

  saveEquipmentInfo(state, saveEquipmentInfo) {
    state.saveEquipmentInfo = saveEquipmentInfo;
  },

  saveHvacEquipmentInfo(state, saveHvacEquipmentInfo) {
    state.saveHvacEquipmentInfo = saveHvacEquipmentInfo;
  },

  saveHvacConfig(state, saveHvacConfig) {
    state.saveHvacConfig = saveHvacConfig;
  },

  setEquipmentInfo(state, setEquipmentInfo) {
    state.setEquipmentInfo = setEquipmentInfo;
  },

  saveCompanyInfo(state, saveCompanyInfo) {
    state.saveCompanyInfo = saveCompanyInfo;
  },

  setCompanyInfo(state, setCompanyInfo) {
    state.setCompanyInfo = setCompanyInfo;
  },

  saveApptointmentCreatelObject(state, saveApptointmentCreatelObject) {
    state.saveApptointmentCreatelObject = saveApptointmentCreatelObject;
  },

  saveApptointmentActionArrived(state, saveApptointmentActionArrived) {
    state.saveApptointmentActionArrived = saveApptointmentActionArrived;
  },

  saveApptointmentActionEnroute(state, saveApptointmentActionEnroute) {
    state.saveApptointmentActionEnroute = saveApptointmentActionEnroute;
  },

  setAppointmentAction(state, appointmentAction) {
    state.appointmentAction = appointmentAction;
  },

  setAppointmentDetails(state, getAppointmentDetails) {
    state.getAppointmentDetails = getAppointmentDetails;
  },

  saveApptDetailObject: (state, appt) => {
    state.apptDetail = appt;
  },

  setSilentLogin(state, isSilentLogin) {
    state.isSilentLogin = isSilentLogin;
  },

  SSOLogin(state, isSSOLogin) {
    state.isSSOLogin = isSSOLogin;
  },

  saveUserObject: (state, user) => {
    state.user = user;
  },

  storeUserObject: (state, user) => {
    state.userObject = user;
  },

  storeUpdatedUser: (state, user) => {
    state.updatedUser = user;
  },

  saveDashboardData: (state, data) => {
    state.dashboardData = data;
  },

  apiCallback: (state, apiCallback) => {
    state.apiCallback = apiCallback;
  },

  notesData: (state, notesData) => {
    state.notesData = notesData;
  },

  savePartCategories: (state, partCategories) => {
    state.partCategories = partCategories;
  },

  savePartList: (state, partList) => {
    state.partList = partList;
  },

  storeQuoteItems: (state, storeQuoteItems) => {
    state.storeQuoteItems = storeQuoteItems;
  },

  storeQuoteDetail: (state, quoteDetail) => {
    state.quoteDetail = quoteDetail;
  },

  cancelReason: (state, cancelReasons) => {
    state.cancelReasons = cancelReasons;
  },

  storeQuoteSummary: (state, quoteSummary) => {
    state.quoteSummary = quoteSummary;
  },

  updateQuoteSummary: (state, updateQuoteSummary) => {
    state.updateQuoteSummary = updateQuoteSummary;
  },

  storeQuoteNotes: (state, qouteNotes) => {
    state.qouteNotes = qouteNotes;
  },

  updateComponentState: (state, componentState) => {
    state.componentState = componentState;
  },

  checkoutResponse: (state, checkoutResponse) => {
    state.checkoutResponse = checkoutResponse;
  },

  qrResponse: (state, qrResponse) => {
    state.qrResponse = qrResponse;
  },

  emailQuoteResponse: (state, quoteEmailResponse) => {
    state.quoteEmailResponse = quoteEmailResponse;
  },

  quoteImageUploaded: (state, quoteImageUploaded) => {
    state.quoteImageUploaded = quoteImageUploaded;
  },

  saveBookingImage: (state, data) => {
    state.bookingImageUploaded = data;
  },
  saveInProgressJobs: (state, data) => {
    state.inProgressJobs = data;
  },

  saveQRData: (state, data) => {
    state.QRData = data;
  },

  saveCompletedJobs: (state, data) => {
    state.completedJobs = data;
  },


  storeProtectionPlans: (state, protectionPlans) => {
    state.protectionPlans = protectionPlans;
  },

  storeProtectionPlanDetails: (state, protectionPlanDetails) => {
    state.protectionPlanDetails = protectionPlanDetails;
  },

  storeProtectionPlanBundleDetailsData: (state, data) => {
    state.protectionPlanBundleDetailsCallBack = data;
  },


  storeCartCount: (state, cartCountResponse) => {
    state.cartCountResponse = cartCountResponse;
  },

  storeCartDetails: (state, cartDetails) => {
    state.cartDetails = cartDetails;
  },


  storeValidateCart: (state, data) => {
    state.cartValidate = data;
  },

  storeUpsertCart: (state, cartUpdated) => {
    state.cartUpdated = cartUpdated;
    state.bundleQuantityUpdated = true
  },

  updateBundleQuantity: (state, data) => {
    state.bundleQuantityUpdated = data
  },

  storeConsumerDetails: (state, consumerDetails) => {
    state.consumerDetails = consumerDetails;
  },

  storeConsumerAddresses: (state, consumerAddresses) => {
    state.consumerAddresses = consumerAddresses;
  },

  storeConsumerBindCart: (state, consumerBindCartResponse) => {
    state.consumerBindCartResponse = consumerBindCartResponse;
  },

  storeCartCheckout: (state, cartCheckoutResponse) => {
    state.cartCheckoutResponse = cartCheckoutResponse;
  },

  storeProtectionPlanSalesListing: (state, protectionPlanSalesListing) => {
    state.protectionPlanSalesListing = protectionPlanSalesListing;
  },

  storeBillingTransactionListing: (state, billingTransactionListing) => {
    state.billingTransactionListing = billingTransactionListing;
  },

  storePaymentCardListing: (state, paymentCardListing) => {
    state.paymentCardListing = paymentCardListing;
  },

  storeCommissionsList: (state, commissionsList) => {
    state.commissionsList = commissionsList;
  },

  storeDeleteAddressResponse: (state, deleteAddressResponse) => {
    state.deleteAddressResponse = deleteAddressResponse;
  },

  storeFormattedAddress: (state, formattedAddress) => {
    state.formattedAddress = formattedAddress;
  },

  storeAddConsumerAddress: (state, consumerAddressStoreResponse) => {
    state.consumerAddressStoreResponse = consumerAddressStoreResponse;
  },

  storeConsumerResponse: (state, addConsumerResponse) => {
    state.addConsumerResponse = addConsumerResponse;
  },

  storePurchasePlanDetails: (state, salesPlanDetails) => {
    state.salesPlanDetails = salesPlanDetails;
  },

  storeCompanyReferalCode: (state, companyReferalCode) => {
    state.companyReferalCode = companyReferalCode;
  },

  storeResendCode: (state, resendCodeResponse) => {
    state.resendCodeResponse = resendCodeResponse;
  },

  storeUpdateStatus: (state, updateStatusResponse) => {
    state.updateStatusResponse = updateStatusResponse;
  },

  storeSignOut: (state, signOutResponse) => {
    state.signOutResponse = signOutResponse;
  },

  storeNotificationResponse: (state, notificationResponse) => {
    state.notificationResponse = notificationResponse;
  },

  storeNotificationCountResponse: (state, notificationCountResponse) => {
    state.notificationCountResponse = notificationCountResponse;
  },

  storeSearchResults: (state, searchResults) => {
    state.searchResults = searchResults;
  },

  storeResetAuthResponse: (state, resetAuthResponse) => {
    state.resetAuthResponse = resetAuthResponse;
  },

  storeResetResendCodeResponse: (state, resetResendCodeResponse) => {
    state.resetResendCodeResponse = resetResendCodeResponse;
  },

  storeResetVerifyResponse: (state, resetVerifyResponse) => {
    state.resetVerifyResponse = resetVerifyResponse;
  },

  storeResetPasswordResponse: (state, resetPasswordResponse) => {
    state.resetPasswordResponse = resetPasswordResponse;
  },

  storeShareProtectionPlans: (state, shareProtectionPlans) => {
    state.shareProtectionPlans = shareProtectionPlans;
  },

  storeShareProtectionPlanURL: (state, shareProtectionPlanURL) => {
    state.shareProtectionPlanURL = shareProtectionPlanURL;
  },

  storeSendProtectionPlanURL: (state, sendProtectionPlanURLResponse) => {
    state.sendProtectionPlanURLResponse = sendProtectionPlanURLResponse;
  },

  storePreviousEvaluation: (state, previousEvaluation) => {
    state.previousEvaluation = previousEvaluation;
  },

  storePreviousEvaluationResponse: (state, previousEvaluationResponse) => {
    state.previousEvaluationResponse = previousEvaluationResponse;
  },

  storeCreateInvoiceResponse: (state, createInvoiceResponse) => {
    state.createInvoiceResponse = createInvoiceResponse;
  },

  storeInvoiceDetail: (state, invoiceDetail) => {
    state.invoiceDetail = invoiceDetail;
  },

  storeCheckoutResponse: (state, quoteCheckoutResponse) => {
    state.quoteCheckoutResponse = quoteCheckoutResponse;
  },

  storeNotesData: (state, notesDataResponse) => {
    state.notesDataResponse = notesDataResponse;
  },

  storeSignaturePaymentLinkResponse: (state, signaturePaymentLinkResponse) => {
    state.signaturePaymentLinkResponse = signaturePaymentLinkResponse;
  },

  storePaymentLinkCheckoutResponse: (state, paymentLinkCheckoutResponse) => {
    state.paymentLinkCheckoutResponse = paymentLinkCheckoutResponse;
  },

  storeSideMenu: (state, resp) => {
    state.sideMenuData = resp;
  },

  storeUserAccountDetails: (state, userAccountDetails) => {
    state.userAccountDetails = userAccountDetails;
  },

  storeUploadMediaResponse: (state, uploadMediaResponse) => {
    state.uploadMediaResponse = uploadMediaResponse;
  },

  storeInternalCheckoutResponse: (state, internalCheckoutResponse) => {
    state.internalCheckoutResponse = internalCheckoutResponse;
  },

  storeTermsAndConditionsResponse: (state, termsAndConditionsResponse) => {
    state.termsAndConditionsResponse = termsAndConditionsResponse;
  },

  storeAffiliateList: (state, affiliateList) => {
    state.affiliateList = affiliateList;
  },

  storeAffiliateDetails: (state, affiliateDetails) => {
    state.affiliateDetails = affiliateDetails;
  },

  storeUpdateAffiliateResponse: (state, updateAffiliateResponse) => {
    state.updateAffiliateResponse = updateAffiliateResponse;
  },

  storePasswordResetResponse: (state, passwordResetResponse) => {
    state.passwordResetResponse = passwordResetResponse;
  },

  storeAddonPlanDetails: (state, addonPlanDetails) => {
    state.addonPlanDetails = addonPlanDetails;
  },

  storeConnectivityCheckDetails: (state, connectivityCheckDetails) => {
    state.connectivityCheckDetails = connectivityCheckDetails;
  },

  storeConnectivityInitDetails: (state, connectivityInitDetails) => {
    state.connectivityInitDetails = connectivityInitDetails;
  },

  storeUpdateStripeDetails: (state, updateStripeDetails) => {
    state.updateStripeDetails = updateStripeDetails;
  },

  storePrivacyPolicyDetails: (state, updatePrivacyPolicyDetails) => {
    state.updatePrivacyPolicyDetails = updatePrivacyPolicyDetails;
  },

  storeContractorAgreementDetails: (state, updateContractorAgreementDetails) => {
    state.updateContractorAgreementDetails = updateContractorAgreementDetails;
  },

  storeUpdatePasswordResponse: (state, updatePasswordResponse) => {
    state.updatePasswordResponse = updatePasswordResponse;
  },

  storeContactUsResponse: (state, contactUsResponse) => {
    state.contactUsResponse = contactUsResponse;
  },

  storeRequestOtp: (state, requestOtpResponse) => {
    state.requestOtpResponse = requestOtpResponse;
  },

  storeUserRegister: (state, userRegisterResponse) => {
    state.userRegisterResponse = userRegisterResponse;
  },

  storeUserVerify: (state, userVerifyResponse) => {
    state.userVerifyResponse = userVerifyResponse;
  },

  storeConsumerCartUpdate: (state, consumerCartUpdateResponse) => {
    state.consumerCartUpdateResponse = consumerCartUpdateResponse;
  },

  storeCartModalState: (state, cartModalState) => {
    state.cartModalState = cartModalState;
  },

  storePurchaseCancelValidateResponse: (state, purchaseCancelValidateResponse) => {
    state.purchaseCancelValidateResponse = purchaseCancelValidateResponse;
  },

  storeCardDefaultResponse: (state, cardDefaultResponse) => {
    state.cardDefaultResponse = cardDefaultResponse;
  },

  storeCardDeleteResponse: (state, cardDeleteResponse) => {
    state.cardDeleteResponse = cardDeleteResponse;
  },

  storePurchasePlanCancelResponse: (state, purchasePlanCancelResponse) => {
    state.purchasePlanCancelResponse = purchasePlanCancelResponse;
  },

  storeSocialUserResponse: (state, socialUserResponse) => {
    state.socialUserResponse = socialUserResponse;
  },

  storeAddCreditCardResponse: (state, addCreditCardResponse) => {
    state.addCreditCardResponse = addCreditCardResponse;
  },

  storeShortenUrlResponse: (state, shortenUrlResponse) => {
    state.shortenUrlResponse = shortenUrlResponse;
  },

  storeClientIdentifierResponse: (state, clientIdentifierResponse) => {
    state.clientIdentifierResponse = clientIdentifierResponse;
  },

  storeCheckoutTotalResponse: (state, checkoutTotalResponse) => {
    state.checkoutTotalResponse = checkoutTotalResponse;
  },

  storeBindPromoCodeResponse: (state, bindPromoCodeResponse) => {
    state.bindPromoCodeResponse = bindPromoCodeResponse;
  },

  storeSidebarCollapsedState: (state, sidebarCollapsedState) => {
    state.sidebarCollapsedState = sidebarCollapsedState;
  },

  storeUnBindPromoCodeResponse: (state, unbindPromoCodeResponse) => {
    state.unbindPromoCodeResponse = unbindPromoCodeResponse;
  },

  storeWorkOrderListing: (state, workOrderListing) => {
    state.workOrderListing = workOrderListing;
  },

  storeWorkOrderDetailResponse: (state, workOrderDetailResponse) => {
    state.workOrderDetailResponse = workOrderDetailResponse;
  },

  storeCancelReasons: (state, cancelClaimReasons) => {
    state.cancelClaimReasons = cancelClaimReasons;
  },

  storeCancelClaimResponse: (state, cancelClaimResponse) => {
    state.cancelClaimResponse = cancelClaimResponse;
  },

  storePaymentRetryObject: (state, paymentRetryObject) => {
    state.paymentRetryObject = paymentRetryObject;
  },

  storePaymentRetryResponse: (state, paymentRetryResponse) => {
    state.paymentRetryResponse = paymentRetryResponse;
  },
  
  storeRatingReviewConfigResponse: (state, ratingReviewConfigResponse) => {
    state.ratingReviewConfigResponse = ratingReviewConfigResponse;
  },

  storeRatingReviewResponse: (state, ratingReviewResponse) => {
    state.ratingReviewResponse = ratingReviewResponse;
  },

  storeClaimResheduleResponse: (state, claimResheduleResponse) => {
    state.claimResheduleResponse = claimResheduleResponse;
  },

  saveUserObjectFailed: (state, userFailedResponse) => {
    state.userFailedResponse = userFailedResponse;
  },
};

let activeRequests = 0;
let loaderTimeout = null;
function startLoader() {
  activeRequests++;
  if (activeRequests == 1) {
    globals.$loader.show();
    loaderTimeout = setTimeout(() => {
      activeRequests = 0;
      globals.$loader.hide();
    }, 20000); // 20 seconds
  }

}

function hideLoader() {
  if (activeRequests > 0) {
    activeRequests--;
  }
  if (activeRequests == 0) {
    globals.$loader.hide();
    if (loaderTimeout) {
      clearTimeout(loaderTimeout);
      loaderTimeout = null;
    }
  }
}

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
